







import { Component, Prop } from "vue-property-decorator";

import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";

import NumberInput from "@share/common/controls/number-input/NumberInput.vue";

@Component({ components: { NumberInput }})

export default class DurationInput extends BaseBorderless {

  @Prop() declare value: string;

}

